// Data layer for address lookup: handles API call.
// Adressevælger API requires a token but currently does not authenticate it: it only has to be at least ten arbitrary characters.

export const ADDRESS_API_URL = 'https://adressevaelger.dk'
export const ADDRESS_API_TOKEN = 'adressevaelger123' // recommended token by KDS: https://confluence.kds.dk/display/ADV/Brugerstyring

const SEARCH_TYPE = 'adresser'
const AVAILABILITY_QUERY = 'Strandboulevarden 49'
const MAX_AVAILABILITY_MS = 3000

let availabilityCheck

async function request(url) {
    const response = await fetch(url)

    if (!response.ok) {
        throw new Error(`Adressevælger svarede med ${response.status}`)
    }

    const body = await response.json()

    if (body.status === 'fejl') {
        throw new Error(body.beskrivelse)
    }

    return body
}

export function searchAddresses(text, { maksimum } = {}) {
    const params = new URLSearchParams({ tekst: text, token: ADDRESS_API_TOKEN })

    if (maksimum) {
        params.set('maksimum', maksimum)
    }

    return request(`${ADDRESS_API_URL}/${SEARCH_TYPE}/soeg?${params}`).then(
        (body) => body.fund ?? []
    )
}

export function getAddress(id) {
    return request(
        `${ADDRESS_API_URL}/${SEARCH_TYPE}/${id}?token=${ADDRESS_API_TOKEN}`
    ).then((body) => body.adresse)
}

export function isFinalSelection(item) {
    return item?.type === 'adresse'
}

export function isAddressSuggestion(item) {
    return item?.type === 'adresse' || item?.type === 'husnummer'
}

export function isStreet(item) {
    return (
        item?.type === 'vejnavn' || item?.type === 'navngivenvejpostnummer'
    )
}

export function toStreetPrefill(item) {
    const street = item.vejnavn ?? item.titel
    const postalDistrict = item.postnr
        ? ` ${item.postnr} ${item.postdistrikt ?? ''}`.trimEnd()
        : ''

    return {
        value: `${street} ${postalDistrict}`,
        caret: street.length + 1
    }
}

export function toAddressFields(adresse) {
    const husnummer = adresse?.husnummer

    if (!husnummer) {
        return null
    }

    const addressLine = [
        husnummer.vejnavn,
        husnummer.husnummertekst,
        adresse.etagebetegnelse,
        adresse.doerbetegnelse
    ]
        .filter(Boolean)
        .join(' ')

    return {
        addressLine,
        zipCode: husnummer.postnummer?.postnr ?? '',
        city: husnummer.postnummer?.navn ?? ''
    }
}

// One probe per page load, shared by every address field on the page
export function isAddressServiceAvailable() {
    if (!availabilityCheck) {
        const timeout = new Promise((resolve) => {
            setTimeout(() => resolve(true), MAX_AVAILABILITY_MS)
        })

        const probe = searchAddresses(AVAILABILITY_QUERY, { maksimum: 1 })
            .then(() => true)
            .catch(() => false)

        availabilityCheck = Promise.race([probe, timeout])
    }

    return availabilityCheck
}
